module.exports = __webpack_public_path__ + "static/media/More.6a0e7602.svg";